import isPropValid from '@emotion/is-prop-valid'
import styled from 'styled-components'

export const WebsitePublicPageLayoutContainerUi = styled.div.withConfig({
  shouldForwardProp: isPropValid,
})<{
  backgroundColor?: string
}>`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${props => props.backgroundColor || 'inherit'};

`

export const WebsitePublicPageHeaderUi = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 17px 150px;

  ${p => p.theme.phone} {
    padding: 10px 20px;
  }
`

export const WebsitePublicPageLanguageSwitcherContainerUi = styled.div`
  margin-left: auto;
`

export const WebsitePublicPageMainUi = styled.main.withConfig({
  shouldForwardProp: isPropValid,
})<{
  backgroundColor?: string
}>`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.backgroundColor || 'inherit'};
`

export const WebsitePublicPageContentUi = styled.div.withConfig({
  shouldForwardProp: isPropValid,
})<{
  backgroundColor?: string
}>`
  width: fit-content;
  max-width: 600px;
  width: 100%;
  background-color: ${props => props.backgroundColor || 'inherit'};
  padding: 60px;
  border-radius: 12px;

  ${p => p.theme.phone} {
    width: 100%;
    padding: 20px;
    min-width: auto;
    margin: 0 20px
  }
`
